// Public exports for the FAQ module

export { FAQsPage } from './components/FAQsPage/FAQsPage';
export { FAQSearchResultItem } from './components/FAQSearchResultItem/FAQSearchResultItem';
export type { FAQSearchResultItemProps } from './components/FAQSearchResultItem/FAQSearchResultItem';
export { AdminFAQsPage } from './components/AdminFAQsPage/AdminFAQsPage';
export * from './types';

// Admin hub registration card for this module
import type { AdminCard } from '../../admin/types';

export const faqAdminCard: AdminCard = {
  title: 'FAQs',
  description: 'Manage sections, categories and FAQ entries for the FAQs page.',
  subCards: [
    {
      title: 'FAQ Entries',
      description: 'Manage sections, categories and FAQ entries by team.',
      to: '/oneadvanced-admin/faqs',
    },
  ],
};
